import { useMemo } from 'react';

/**
 * Hook to validate items for deletion based on their status
 * Only items with status 'Available' can be deleted
 *
 * @param {Array} items - Array of items to validate
 * @returns {Object} Validation results
 */
export const useItemsDeletionValidation = (items = []) => {
  return useMemo(() => {
    // Filter items based on their status
    const availableItems = items.filter(item => item.status?.name === 'Available');

    const unavailableItems = items.filter(item => item.status?.name !== 'Available');

    // Analysis results
    const analysis = {
      availableItems,
      unavailableItems,
      totalItems: items.length,
      availableCount: availableItems.length,
      unavailableCount: unavailableItems.length,
      canDeleteAll: unavailableItems.length === 0,
      hasItems: items.length > 0,
      hasUnavailableItems: unavailableItems.length > 0,
      hasAvailableItems: availableItems.length > 0
    };

    return analysis;
  }, [items]);
};

export default useItemsDeletionValidation;

